// ** Initial State
const initialState = {
  allData: [],
  data: [],
  total: 1,
  params: {},
  selected: null
}
const typeName = 'CUSTOMERS';

const customers = (state = initialState, action) => {
  switch (action.type) {
    case `GET_ALL_DATA_${typeName}`:
      return { ...state, allData: action.data }
    case `GET_DATA_${typeName}`:
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    case `GET_${typeName}`:
      return { ...state, selected: action.selected }
    case `ADD_${typeName}`:
      return { ...state }
    case `DELETE_${typeName}`:
      return { ...state }
    default:
      return { ...state }
  }
}
export default customers
